<template>
  <li class="pick-item-container">
    <component :is="Currcomp" :item="item"></component>
    <!-- <div class="radio-btn" :class="{ selected: selected }" v-show="showSelectIcon"></div> -->
  </li>
</template>

<script>
import RecycleBookList from './RecycleBookList'
import NormalList from './NormalList'
// import NormalList from '../order-detail-info/NormalList'

const compMap = {
  9: RecycleBookList
}
export default {
  name: 'PickItemContainer',
  components: {
    RecycleBookList,
    NormalList
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
    // selected: {
    //   type: Boolean,
    //   default: false
    // },
    // showSelectIcon: {
    //   type: Boolean,
    //   default: true
    // }
  },
  computed: {
    Currcomp() {
      return compMap[this.item.orderSource] || NormalList
    }
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
